<div class="header">
  <label class="textColour">{{ titleText }}</label>
</div>

<form [formGroup]="form" class="popup-form">

  <!-- RULE IDENTIFICATION : 3 x 3 GRID -->
  <div class="grid-3">

    <mat-form-field appearance="outline">
      <mat-label>Rule Type</mat-label>
      <mat-select formControlName="ruleType" [errorStateMatcher]="errorStateMatcher">
        <mat-option *ngFor="let r of AlertRuleType" [value]="r.lookupvalue">{{ r.lookupvalue }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('ruleType')?.hasError('required')">
        Rule Type is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Data Source</mat-label>
      <mat-select formControlName="dataSource" [errorStateMatcher]="errorStateMatcher">
        <mat-option *ngFor="let d of DataSource" [value]="d.lookupvalue">{{ d.lookupvalue }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('dataSource')?.hasError('required')">
        Data Source is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Periodicity</mat-label>
      <mat-select formControlName="periodicity" [errorStateMatcher]="errorStateMatcher">
        <mat-option *ngFor="let p of Periodicity" [value]="p.lookupvalue">{{ p.lookupvalue }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('periodicity')?.hasError('required')">
        Periodicity is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Alerting Rule Name</mat-label>
      <input matInput formControlName="ruleName" [errorStateMatcher]="errorStateMatcher">
      <mat-error *ngIf="form.get('ruleName')?.hasError('required')">
        Alerting Rule Name is required
      </mat-error>
      <mat-error *ngIf="form.get('ruleName')?.hasError('specialCharacter')">
         Special characters are not allowed
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="span-2">
      <mat-label>Description</mat-label>
      <textarea matInput rows="1" formControlName="description"></textarea>
      <mat-error *ngIf="form.get('description')?.hasError('specialCharacter')">
         Special characters are not allowed
      </mat-error>
    </mat-form-field>

  </div>

<!-- EXPRESSION BUILDER FULL WIDTH -->

<section
  class="expression-section"
>
  <div class="section-header">
    <mat-icon>account_tree</mat-icon>
    <span>Alert Logic  
      <ng-container *ngIf="readableLogic">
      : {{ readableLogic }}
    </ng-container></span>
  </div>

  <app-expression-builder
     #exprBuilder
    [isRoot]="true"
    formControlName="logic"
    [fields]="alertFields"
    [operators]="alertOperators"
    [groupOperators]="groupOps"
    (expressionChange)="onExpressionChange($event)"
  >
  </app-expression-builder>


</section>

  <!-- Errors -->

<div class="expression-errors">
 <mat-error *ngIf="
    formSubmitted && 
    form.get('logic')?.hasError('emptyExpression')
  ">
    At least one rule is required
  </mat-error>

<mat-error *ngIf="
    formSubmitted && 
    form.get('logic')?.hasError('invalidExpression')
  ">
    Rule definition is incomplete
  </mat-error>
</div>


  <!-- GOVERNANCE -->
  <div class="governance">
    <mat-checkbox formControlName="active">Active</mat-checkbox>
    <mat-checkbox formControlName="defaultRule">Default Rule</mat-checkbox>
    <mat-checkbox formControlName="exceptionAllowed">Exception Allowed</mat-checkbox>
  </div>

  <!-- ACTIONS -->
  <div class="actions">
    <app-common-button
    label="Back"
    title="Back"
    [buttonId]="1111"
    variant="cancel"
    width="110px"
    [critical]="false"
    (clicked)="onCancel()"
    style="margin-left:6px;margin-right:6px;">
  </app-common-button>

    <app-common-button
    label="Submit"
    title="Submit"
    [buttonId]="1111"
    width="110px"
    [critical]="false"
    (clicked)="onSubmit()"
    style="margin-left:6px;margin-right:6px;">
  </app-common-button>
  </div>

</form>
